import React, { useMemo } from 'react';
import { List, ListProps } from 'react-virtualized';
import RenderRow from './List.RenderRow';
import injectStores from '../RootStore/injectStores';

const style = {
  List: {
    width: '100%',
    marginTop: '15px',
    overflow: 'auto',
  },
  margin: {
    marginTop: '15px',
  },
};

export interface customRowRendererProps {
  rowKey: string;
  rowData: unknown;
  index: number;
  style: React.CSSProperties;
  isScrolling?: boolean;
}

interface StandardListProps {
  rows: unknown[];
  height: number;
  width: number;
  overscanRowCount?: number;
  rowHeight?: number;
  scrollToIndex?: number;
  sortBy?: (a: unknown, b: unknown) => number;
  customRowRenderer?: (props: customRowRendererProps) => JSX.Element;
  noMargin?: boolean;
}

const StandardList = injectStores(
  (props: StandardListProps) => {
    const {
      rows,
      height,
      width,
      overscanRowCount = 10,
      rowHeight = 50,
      scrollToIndex,
      sortBy,
      customRowRenderer = ({ rowData }: customRowRendererProps) => <div>{String(rowData)}</div>,
      noMargin,
    } = props;

    const listRows = useMemo(() => {
      if (sortBy) return [...rows].sort(sortBy);
      return rows;
    }, [rows, sortBy]);

    const rowCount = useMemo(() => {
      return rows ? rows.length : 0;
    }, [rows]);

    const noRowsRenderer = () => {
      return <div>No Data</div>;
    };

    const styles = noMargin ? style.List : { ...style.List, ...style.margin };

    // Use JSX.Element to bypass the typing issues
    const VirtualList = List as unknown as React.FC<ListProps>;

    return (
      <VirtualList
        style={styles}
        height={height}
        width={width}
        overscanRowCount={overscanRowCount}
        noRowsRenderer={noRowsRenderer}
        rowCount={rowCount}
        rowHeight={rowHeight}
        rowRenderer={(rowData) =>
          RenderRow({
            ...rowData,
            customRowRenderer: customRowRenderer,
            rows: listRows,
          })
        }
        scrollToIndex={scrollToIndex}
      />
    );
  }
);

export default StandardList;
